import { graphql } from 'gatsby';
import { Suspense } from 'react';

import { FrDisabilityGapSimulator, JobPostings } from '~lazy-components';

import type { ContentBlock } from '~components/types';

type CustomComponent = 'fr-disability-gap-simulator' | 'lever-job-postings';

export type ContentfulComponentCustomContent = {
  __typename: 'ContentfulComponentCustom';
  component: CustomComponent;
  translations?: Record<string, unknown>;
};

type ContentfulComponentCustomProps = {
  content: ContentfulComponentCustomContent;
};

const ContentfulComponentCustom: ContentBlock<ContentfulComponentCustomProps> = ({ content, ...sectionProps }) => {
  const getComponent = () => {
    switch (content.component) {
      case 'fr-disability-gap-simulator':
        return <FrDisabilityGapSimulator {...sectionProps} />;
      case 'lever-job-postings':
        return <JobPostings {...sectionProps} />;
      default:
        return <></>;
    }
  };

  return <Suspense>{getComponent()}</Suspense>;
};

export default ContentfulComponentCustom;

export const query = graphql`
  fragment ComponentCustom on ContentfulComponentCustom {
    __typename
    name
    component
  }
`;
